import { createVueUi } from "@lunagoai/vue-ui";
import { Languages, LogOut, UserRound } from "lucide-vue-next";
import type { Plugin } from "vue";

export const gcsVueUi = createVueUi({
  icons: { Languages, LogOut, UserRound },
  theme: {
    light: {
      primary: "#0891b2",
      primaryLight: "#06b6d4",
      primaryHover: "#0e7490",
      surface: "#f0f4f8",
      surfaceMuted: "#e5edf5",
      surfaceElevated: "#ffffff",
      surfaceInverse: "#0f172a",
      tooltipSurface: "#0f172a",
      tooltipText: "#f8fafc",
      tooltipBorder: "#334155",
      shadow: "rgba(15, 23, 42, 0.16)",
      text: "#0f172a",
      textMuted: "#475569",
      textDim: "#64748b",
      border: "#c7d4e2",
      borderStrong: "#9fb2c5",
      scrollbarThumb: "#9fb2c5",
      scrollbarThumbHover: "#7f96ad",
      scrollbarTrack: "transparent",
      focus: "#0891b2",
      success: "#047857",
      warning: "#b45309",
      danger: "#be123c",
      info: "#0369a1",
    },
    dark: {
      primary: "#06b6d4",
      primaryLight: "#67e8f9",
      primaryHover: "#22d3ee",
      surface: "#111827",
      surfaceMuted: "#020617",
      surfaceElevated: "#1e293b",
      surfaceInverse: "#ffffff",
      tooltipSurface: "#0f172a",
      tooltipText: "#f8fafc",
      tooltipBorder: "#334155",
      shadow: "rgba(0, 0, 0, 0.55)",
      text: "#f8fafc",
      textMuted: "#94a3b8",
      textDim: "#64748b",
      border: "#1e293b",
      borderStrong: "#334155",
      scrollbarThumb: "#475569",
      scrollbarThumbHover: "#64748b",
      scrollbarTrack: "transparent",
      focus: "#67e8f9",
      success: "#4ade80",
      warning: "#fbbf24",
      danger: "#f87171",
      info: "#67e8f9",
    },
  },
}) as unknown as Plugin;
